import { clamp } from "ramda";
import { useState } from "react";

function usePaging(
  minPage,
  maxPage,
  pageOffset,
  onPageChange,
  toReadable,
  fromReadable,
  initialPage = 1
) {
  const [currentPage, setCurrentPage] = useState(initialPage);
  if (currentPage !== initialPage) setCurrentPage(initialPage);

  let displayPage = currentPage;

  if (currentPage > pageOffset) {
    displayPage = currentPage - pageOffset;
  } else {
    displayPage = toReadable(currentPage);
  }

  function setCurrentPageClamped(value) {
    const page = clamp(minPage, maxPage, value);

    if (currentPage !== page) {
      setCurrentPage(page);
      onPageChange(page);
    }
  }

  function goToPrevious() {
    setCurrentPageClamped(currentPage - 1);
  }

  function goToNext() {
    setCurrentPageClamped(currentPage + 1);
  }

  function gotToAbsolutePage(absolutePage) {
    setCurrentPageClamped(absolutePage);
  }

  function gotToReadablePage(readablePage) {
    const numericPage = parseInt(readablePage, 10);

    if (Number.isNaN(numericPage)) {
      const page = fromReadable(readablePage);

      if (page > 0 && page <= pageOffset) {
        setCurrentPageClamped(page);
      }
    } else {
      setCurrentPageClamped(numericPage + pageOffset);
    }
  }

  return {
    absolutePage: currentPage,
    readablePage: displayPage,
    goToPrevious,
    goToNext,
    gotToAbsolutePage,
    gotToReadablePage
  };
}

export default usePaging;
